const forms = {
  title: "Create Custom Form Templates from Anvil's Form Library",
  description:
    "Utilize the prebuilt PDF templates and Workflows from Anvil to speed up your paperwork automation journey. Don't reinvent the wheel, reuse tried and true online document templates and webforms.",
  keywords:
    'acord 125,acord 25,acord 140,acord 126,pdf templates,pdf workflows,online pdfs,anvil workflows',
  socialTagline: '',
}

const formsInsurance = {
  title: 'Anvil | Insurance Form Library',
  description:
    "Utilize prebuilt Insurance PDF templates and Workflows from Anvil to speed up your paperwork automation journey. Don't reinvent the wheel, reuse tried and true online document templates and webforms.",
  keywords:
    'acord 125,acord 25,acord 140,acord 126,pdf templates,pdf workflows,online pdfs,anvil workflows',
  socialTagline: '',
}

const formsTaxes = {
  title: 'Anvil | Tax Form Library',
  description:
    "Utilize prebuilt Tax PDF templates and Workflows from Anvil to speed up your paperwork automation journey. Don't reinvent the wheel, reuse tried and true online document templates and webforms.",
  keywords: '',
  socialTagline: '',
}

const formsBusiness = {
  title: 'Anvil | Business Form Library',
  description:
    "Utilize prebuilt Business PDF templates and Workflows from Anvil to speed up your paperwork automation journey. Don't reinvent the wheel, reuse tried and true online document templates and webforms.",
  keywords: '',
  socialTagline: '',
}

const formsRealEstate = {
  title: 'Anvil | Real Estate Form Library',
  description:
    "Utilize prebuilt Real Estate PDF templates and Workflows from Anvil to speed up your paperwork automation journey. Don't reinvent the wheel, reuse tried and true online document templates and webforms.",
  keywords: '',
  socialTagline: '',
}

const formsEmployment = {
  title: 'Anvil | Employment Form Library',
  description:
    "Utilize prebuilt Employment PDF templates and Workflows from Anvil to speed up your paperwork automation journey. Don't reinvent the wheel, reuse tried and true online document templates and webforms.",
  keywords: '',
  socialTagline: '',
}

const formsStudentLoans = {
  title: 'Anvil | Student Loans Form Library',
  description:
    "Utilize prebuilt Student Loans PDF templates and Workflows from Anvil to speed up your paperwork automation journey. Don't reinvent the wheel, reuse tried and true online document templates and webforms.",
  keywords: '',
  socialTagline: '',
}

const formsTravel = {
  title: 'Anvil | Travel Form Library',
  description:
    "Utilize prebuilt Travel PDF templates and Workflows from Anvil to speed up your paperwork automation journey. Don't reinvent the wheel, reuse tried and true online document templates and webforms.",
  keywords: '',
  socialTagline: '',
}

const formsFinance = {
  title: 'Anvil | Finance Form Library',
  description:
    "Utilize prebuilt Finance PDF templates and Workflows from Anvil to speed up your paperwork automation journey. Don't reinvent the wheel, reuse tried and true online document templates and webforms.",
  keywords: '',
  socialTagline: '',
}

const formsHealthcare = {
  title: 'Anvil | Healthcare Form Library',
  description:
    "Utilize prebuilt Healthcare PDF templates and Workflows from Anvil to speed up your paperwork automation journey. Don't reinvent the wheel, reuse tried and true online document templates and webforms.",
  keywords: '',
  socialTagline: '',
}

export default {
  '/forms/': forms,
  '/forms/insurance/': formsInsurance,
  '/forms/taxes/': formsTaxes,
  '/forms/business/': formsBusiness,
  '/forms/real-estate/': formsRealEstate,
  '/forms/employment/': formsEmployment,
  '/forms/student-loans/': formsStudentLoans,
  '/forms/travel/': formsTravel,
  '/forms/finance/': formsFinance,
  '/forms/healthcare/': formsHealthcare,
}
